module.exports = __webpack_public_path__ + "static/media/ENVIRONMENT - 429 C.eac0857a.jpg";